export default "__VITE_ASSET__CudkQdPv__"